import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import {
  DropDownConfig,
  DropDownOption,
} from '../../models/multiselect-dropdown.model';
import { SharedModule } from '../../shared.module';
import { SkeletonLoaderComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-multiselect-dropdown',
  standalone: true,
  imports: [SharedModule, SkeletonLoaderComponent],
  templateUrl: './multiselect-dropdown.component.html',
  styleUrl: './multiselect-dropdown.component.scss',
})
export class MultiselectDropdownComponent implements OnInit, OnDestroy {
  @Input() config: DropDownConfig = {
    allowSearchFilter: false,
    placeholder: '',
    searchPlaceholderText: '',
    title: '',
  };
  @Input() options: (DropDownOption | any)[] = [];
  @Input() control!: any;
  @Input() error: string = '';
  @Input() paginationLoading: boolean = false;
  @Input() optionLoading: boolean = false;
  @Input() pagination: boolean = false;
  @Input() multiselect: Boolean = true;
  @Input() searchable: Boolean = true;
  @Output() lastElementIsVisible: EventEmitter<void> = new EventEmitter();
  @Output() searchEvent: EventEmitter<string> = new EventEmitter();
  @Input() maxHeight = '380px';
  searchForm: FormGroup = this.fb.group({ searchText: [''] });
  showOptions: boolean = false;
  subscription: Subscription = new Subscription();
  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscribeToSearchValueChanges();
  }

  handleOptionClick(value: any) {
    if (value?.isDisabled) {
      return;
    }
    if (this.multiselect) {
      if (value === 'all') {
        if (this.control.value.length === this.options.length) {
          this.control.patchValue([]);
        } else {
          this.control.patchValue([
            ...JSON.parse(JSON.stringify(this.options)),
          ]);
        }
      } else {
        const selected = this.control.value.find(
          (el: any) =>
            el[this.config?.valueField || 'value'] ===
            value[this.config?.valueField || 'value']
        );
        if (selected) {
          const filteredOptions = this.control.value.filter(
            (el: any) =>
              el[this.config?.valueField || 'value'] !==
              value[this.config?.valueField || 'value']
          );
          this.control.patchValue([...filteredOptions]);
        } else {
          this.control.patchValue([...this.control.value, value]);
        }
      }
    } else {
      this.control.patchValue(value);
      this.toggleOption(false);
    }
  }
  handleOutSideClick() {
    this.toggleOption(false);
    this.cd.detectChanges();
  }

  toggleOption(state: boolean) {
    this.showOptions = state;
  }

  handleLastElementIsVisible() {
    this.lastElementIsVisible.emit();
  }

  subscribeToSearchValueChanges() {
    const valueChangeSub = this.searchForm
      .get('searchText')
      ?.valueChanges.pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value: any) => {
        if (value.length === 0 || value?.trim()) {
          this.searchEvent.emit(value);
        }
      });
    this.subscription.add(valueChangeSub);
  }
  removeOption(value: any) {
    this.control.patchValue(
      this.control.value.filter((el: any) => el.value !== value)
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  get selectedOption() {
    return this.multiselect
      ? (this.control.value || []).map(
          (el: any) => el[this.config?.valueField || 'value']
        ) || []
      : this.control.value[this.config?.valueField || 'value'];
  }
}
